module.exports = __webpack_public_path__ + "img/1.717d523e.jpg";